export default __webpack_public_path__ + "static/media/logo_cliente.306d8252.png";